import React from "react";
import InfoSection from "./InfoSection";
import EditableInfoRow from "./EditableInfoRow";

const ProfileInformation = ({ data, isEditing, isLoading, onEdit, onSave, onCancel, onChange }) => {
    const profileInfo = data || {};

    // Check for PAN Number validation error (must be exactly 10 characters if provided)
    const hasPanError = profileInfo.panNumber && profileInfo.panNumber.length > 0 && profileInfo.panNumber.length !== 10;
    // Check for TAN Number validation error (must be exactly 10 characters if provided)
    const hasTanError = profileInfo.tanNumber && profileInfo.tanNumber.length > 0 && profileInfo.tanNumber.length !== 10;

    return (
        <InfoSection
            title="Profile Information"
            icon="solar:user-id-bold"
            isEditing={isEditing}
            isLoading={isLoading}
            hasError={hasPanError || hasTanError}
            onEdit={onEdit}
            onSave={onSave}
            onCancel={onCancel}
        >
            <div className="row">
                <EditableInfoRow
                    label="Society Name"
                    value={profileInfo.societyName}
                    icon="solar:buildings-2-bold-duotone"
                    isEditing={isEditing}
                    fieldKey="societyName"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="Society Name For SMS"
                    value={profileInfo.societyNameForSMS}
                    icon="solar:chat-round-dots-bold-duotone"
                    isEditing={isEditing}
                    fieldKey="societyNameForSMS"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="Made By"
                    value={profileInfo.madeBy}
                    icon="solar:case-minimalistic-bold-duotone"
                    isEditing={isEditing}
                    fieldKey="madeBy"
                    onChange={onChange}
                    maxLength={255}
                    placeholder="e.g. ABC Builders Pvt Ltd"
                />
                <EditableInfoRow
                    label="Pan Number"
                    value={profileInfo.panNumber}
                    icon="solar:card-bold-duotone"
                    isEditing={isEditing}
                    fieldKey="panNumber"
                    onChange={onChange}
                    maxLength={10}
                    minLength={10}
                    errorMessage="PAN Number must be exactly 10 characters"
                />
                <EditableInfoRow
                    label="Tan Number"
                    value={profileInfo.tanNumber}
                    icon="solar:document-text-bold-duotone"
                    isEditing={isEditing}
                    fieldKey="tanNumber"
                    onChange={onChange}
                    maxLength={10}
                    minLength={10}
                    errorMessage="TAN Number must be exactly 10 characters"
                />
            </div>
        </InfoSection>
    );
};

export default ProfileInformation;
